"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTRIBUTE_VISUALIZATION = void 0;
var ATTRIBUTE_VISUALIZATION;
(function (ATTRIBUTE_VISUALIZATION) {
    ATTRIBUTE_VISUALIZATION["GRAYSCALE"] = "grayscale";
    ATTRIBUTE_VISUALIZATION["OPACITY"] = "opacity";
    ATTRIBUTE_VISUALIZATION["BLUE_RED"] = "blue_red";
    ATTRIBUTE_VISUALIZATION["BLUE_WHITE_RED"] = "blue_white_red";
    ATTRIBUTE_VISUALIZATION["GREEN_RED"] = "green_red";
    ATTRIBUTE_VISUALIZATION["GREEN_WHITE_RED"] = "green_white_red";
    ATTRIBUTE_VISUALIZATION["BLUE_GREEN_RED"] = "blue_green_red";
    ATTRIBUTE_VISUALIZATION["BLUE_GREEN_YELLOW_RED_PURPLE_WHITE"] = "blue_green_yellow_red_purple_white";
    ATTRIBUTE_VISUALIZATION["HSL"] = "hsl";
})(ATTRIBUTE_VISUALIZATION = exports.ATTRIBUTE_VISUALIZATION || (exports.ATTRIBUTE_VISUALIZATION = {}));
;
;
//# sourceMappingURL=IAttribute.js.map